
import { debounce } from '@/utils/validate'
export default {
	props: {
		value: {
			type: Boolean,
			default: false
		},
		successCb: {
			type: Function
		}
	},
	data() {
		return {
			loading: false,
			failedReason: '',
			formResult: {
				name: '',
				num: ''
			},
			formRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				num: [
					{ required: true, message: '请输入身份证号', trigger: 'blur' },
					{
						pattern:
							/^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/,
						message: '请输入正确的身份证号',
						trigger: 'blur'
					}
				]
			}
		}
	},
	mounted() {
		// console.log(this.dialogVisible, '5645646-----')
		// this.getAuthService()
	},

	methods: {
		reset() {
			this.failedReason = ''
			this.$refs.formRef?.resetFields?.()
		},
		handleClose() {
			this.reset()
			this.$emit('input', false)
		},
		async getIM() {
			const res = await this.$api.getAuthService()
			if (!res.success) return this.$message.warning(res.info)
			let imId = ''
			if (res.data && res.data.username) {
				imId = res.data.username + ''
			}
			if (!imId) return this.$message.warning('暂无客服值班')
			this.$store.dispatch('ry/join', { targetId: imId, conversationType: 1 })
			this.handleClose()
		},
		onSubmit() {
			// TODO: for dev test
			// this.successCb?.()
			// return
			this.$refs.formRef.validate(valid => {
				if (valid) {
					this.submitForm()
				} else {
					this.loading = false
				}
			})
		},
		submitForm: debounce(async function () {
			this.loading = true
			const data = {
				action: {
					...this.formResult
				}
			}
			const res = await this.$api.userAuthVerify(data)
			this.loading = false
			if (!res.success) {
				this.failedReason = res.info
				return
			} else {
				this.$store.dispatch('user/UserGetInfo')
				this.$message({
					type: 'success',
					message: '实名认证成功'
				})
				this.handleClose()
				this.successCb?.()
			}
		})
	}
}
